<template>
  <div>
    <div v-if="!isHalfCirclePie" class="mt8 mb8">
      <label class="font14 inlineMiddle mr8">数据样式</label>
      <el-select v-model="labelType" class="percent65_ height32" ref="">
        <el-option
          v-for="(item, index) in labelStyleList"
          :key="index"
          :selected="labelType == item.value"
          :value="item.value"
          :label="item.title"
          >{{ item.title }}
        </el-option>
      </el-select>
    </div>
    <collapsibleItem>
      <div slot="heading">形状设置</div>
      <div slot="body">
        <div class="mb16 mt8" v-if="checkType(radius1)">
          <div class="font14 list-label mb8">内环占比</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="radius1"
              :min="0"
              :step="1"
              :max="50"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="radius1"
                inputSuffixs="%"
                placeholder="请输入"
                :max="50"
                :min="0"
                :step="1"
              />
            </div>
          </div>
        </div>
        <div class="mb16" v-if="checkType(radius2)">
          <div class="font14 list-label mb8">外环占比</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="radius2"
              :step="1"
              :min="radius1"
              :max="100"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="radius2"
                inputSuffixs="%"
                placeholder="请输入"
                :max="100"
                :step="1"
                :min="radius1"
              />
            </div>
          </div>
        </div>
        <div class="mb16" v-if="checkType(borderRadius)">
          <div class="font14 list-label mb8">扇形圆角</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="borderRadius"
              :step="1"
              :min="0"
              :max="100"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="borderRadius"
                inputSuffixs="px"
                placeholder="请输入"
                :max="100"
                :min="radius1"
                :step="1"
              />
            </div>
          </div>
        </div>
        <div class="mb16" v-if="checkType(splitWidth)">
          <div class="font14 list-label mr8 mb8">边框</div>
          <div class="verticallyCenter">
            <el-slider
              class="mr16 ml24 percent54 height4"
              v-model="splitWidth"
              :show-tooltip="false"
              :step="1"
              :min="0"
              :max="10"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="splitWidth"
                inputSuffixs="px"
                placeholder="请输入"
                :min="0"
                :step="1"
                :max="10"
              />
            </div>
          </div>
        </div>
        <!--间距颜色-->
        <div class="verticallyCenter mb8" v-if="checkType(splitColor)">
          <label class="font14 mr8">边框颜色</label>
          <div class="color-picker-container percent65_">
            <el-color-picker
              class=""
              v-model="splitColor"
              color-format="rgb"
              :show-alpha="true"
              :predefine="predefineColors"
            ></el-color-picker>
            <span class="color-text overflowHid percent80">{{ splitColor }}</span>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">颜色设置</div>
      <div slot="body">
        <div class="color-container mb8" :key="index" v-for="(colorItem, index) in pieColorList">
          <div>
            <el-radio-group v-model="colorItem.type" @change="changePieColorQuantity(index, colorItem.type)">
              <el-radio label="纯色">纯色</el-radio>
              <el-radio label="线性渐变">线性渐变</el-radio>
            </el-radio-group>
          </div>
          <div v-if="colorItem.type === '纯色'">
            <color-picker :color.sync="colorItem.color" titlePosition="singleLine" />
          </div>
          <div v-if="colorItem.type !== '纯色'" class="mt12">
            <color-picker title="开始颜色" :color.sync="colorItem.startColor" titlePosition="singleLine" />
          </div>
          <div v-if="colorItem.type !== '纯色'" class="mt8">
            <color-picker title="结束颜色" :color.sync="colorItem.endColor" titlePosition="singleLine" />
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">中心点位置</div>
      <div slot="body">
        <div class="mb16 mt8" v-if="checkType(position1)">
          <div class="font14 list-label">距离左边框</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="position1"
              :step="1"
              :min="0"
              :max="100"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="position1"
                inputSuffixs="%"
                placeholder="请输入"
                :min="0"
                :step="1"
                :max="100"
              />
            </div>
          </div>
        </div>
        <div class="mb8" v-if="checkType(position2)">
          <div class="font14 list-label">距离上边框</div>
          <div class="verticallyCenter">
            <el-slider
              :show-tooltip="false"
              class="mr16 ml24 percent54 height4"
              v-model="position2"
              :step="1"
              :min="0"
              :max="100"
            ></el-slider>
            <div class="number-input-box percent46_16">
              <single-input
                class="percent100"
                :value.sync="position2"
                inputSuffixs="%"
                placeholder="请输入"
                :min="0"
                :step="1"
                :max="100"
              />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">标签设置</div>
      <div slot="body" class="mb8">
        <el-checkbox v-model="showLabel">显示标签文字</el-checkbox>
        <div v-if="showLabel">
          <!-- 数据名称 -->
          <div class="mt16" v-if="checkType(labelFormatter)">
            <label class="font14 inlineMiddle mr8">数据名称</label>
            <el-select v-model="labelFormatter" class="percent65_ height32" ref="">
              <el-option
                v-for="(item, index) in labelTypeList"
                :key="index"
                :selected="labelFormatter == item.type"
                :value="item.type"
                :label="item.title"
                >{{ item.title }}
              </el-option>
            </el-select>
          </div>
          <div class="mt16" v-if="checkType(labelFormatter)">
            <!-- 字体和颜色/字重和字号 -->
            <text-setting-update
                class="mb16 nextlinemt8"
                :fontColor.sync="labelFontColor"
                :fontFamily.sync="labelFontFamily"
                :fontSize.sync="labelFontSize"
                :fontWeight.sync="labelFontWeight"
                colorMode="chart"
            />
          </div>
          <numberSetting v-if="labelFormatter === 4 || labelFormatter === 5" :options="options" :ids="ids"></numberSetting>
          <!--显示标签线-->
          <div class="mt16">
            <el-checkbox v-model="showLabelLine">显示标签线</el-checkbox>
          </div>
          <cx-select
            v-if="showLabelLine"
            class="mt16"
            :value.sync="labelSelectData"
            :selectOptions="labelSelectOptions"
            title="标签线样式"
          />
          <!--标签线颜色-->
          <!--          <div class="mt16" v-if="showLabelLine">-->
          <!--            <label class="font14 inlineMiddle mr8">标签线设置</label>-->
          <!--            <div class="color-picker-container inlineMiddle percent100_80" v-if="checkType(labelLineColor)">-->
          <!--              <el-color-picker-->
          <!--                class=""-->
          <!--                v-model="labelLineColor"-->
          <!--                :show-alpha="true"-->
          <!--                :predefine="predefineColors"-->
          <!--              ></el-color-picker>-->
          <!--              <span class="color-text overflowHid percent80">{{ labelLineColor }}</span>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--标签线颜色类型-->
          <div class="data-source-type mt16" v-if="showLabelLine">
            <el-radio-group v-model="labelColorType">
              <el-radio label="default">跟随数据颜色</el-radio>
              <el-radio label="custom">自定义</el-radio>
            </el-radio-group>
          </div>
          <div class="mt16" v-if="showLabelLine">
            <line-setting
              v-if="labelColorType === 'default'"
              :lineName.sync="labelLineType"
              :lineWidth.sync="labelLineWidth"
            />
            <line-setting
              v-if="labelColorType === 'custom'"
              :lineName.sync="labelLineType"
              :lineWidth.sync="labelLineWidth"
              :lineColor.sync="labelLineColor"
            />
          </div>
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "../publicData"
import numberSetting from "toolbarComponents/bigScreen/common/options/numberSetting"

export default {
  mixins: [publicData],
  components: { numberSetting },
  props: {
    seriesData: {
      type: Array
    },
    seriesSettingItem: {
      type: Object
    },
    index: {
      type: Number
    },
    ids: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      pieColorList: [],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      labelTypeList: [
        {
          title: "数据标题",
          value: "{b}",
          type: 1
        },
        {
          title: "百分比",
          value: "{d}%",
          type: 2
        },
        {
          title: "数据标题+百分比",
          value: "{b}:{d}%",
          type: 3
        },
        {
          title: "数值+百分比",
          value: "{c}:{d}%",
          type: 4
        },
        {
          title: "数据标题+数值",
          value: "{b}:{c}",
          type: 5
        }
      ],
      labelStyleList: [
        {
          title: "饼图",
          value: ""
        },
        {
          title: "玫瑰图",
          value: "radius"
        }
      ],
      labelSelectOptions: [
        {
          label: "样式1",
          value: 1
        },
        {
          label: "样式2",
          value: 2
        }
      ]
    }
  },
  created() {
    this.init()
  },
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    },
    pieColorList: {
      deep: true,
      handler(val, oldVal) {
        if (val.length == 0) return
        let params = JSON.parse(JSON.stringify(this.seriesSettingItem))
        let legend = JSON.parse(JSON.stringify(this.options.chartOption.legend))
        val.forEach((item, index) => {
          let colorItem
          if (item.type === "线性渐变") {
            colorItem = {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: item.startColor || item.color // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: item.endColor || item.color // 100% 处的颜色
                }
              ]
            }
          } else {
            colorItem = item.color || item.startColor
          }
          params.data[index].itemStyle.color = colorItem
          if (legend?.data && legend?.data[index]?.itemStyle) {
            legend.data[index].itemStyle.borderColor = colorItem
          }
        })
        this.$changeOptionsEV(params, "chartOption.series." + this.index, false)
        this.$changeOptionsEV(legend, "chartOption.legend", false)
      }
    }
  },
  computed: {
    getOptions: {
      get() {
        return this.$getOptions()
      }
    },
    isHalfCirclePie() {
      // 针对半圆饼图 不能进行数据类型切换
      if (this.seriesData.length > 2 && this.seriesData[1].type === "gauge") {
        return true
      }
      return false
    },
    radius1: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "radius.0", "radius1", "30%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".radius.0", false)
      }
    },
    radius2: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "radius.1", "radius2", "55%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".radius.1", false)
      }
    },
    borderRadius: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "itemStyle.borderRadius", 0))
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.series." + this.index + ".itemStyle.borderRadius", false)
      }
    },
    splitWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "itemStyle.borderWidth", "splitWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.series." + this.index + ".itemStyle.borderWidth", false)
      }
    },
    splitColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.seriesSettingItem,
          "itemStyle.borderColor",
          "splitColor",
          "rgba(0,0,0,0.5)"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".itemStyle.borderColor", false)
      }
    },
    position1: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "center.0", "position1", "50%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".center.0", false)
        this.seriesData.forEach((data, index) => {
          // 针对样式5 后面有那个半圆环的情况
          if (data.type === "gauge") {
            this.$changeOptionsEV(newVal + "%", "chartOption.series." + index + ".center.0", false)
          }
        })
      }
    },
    position2: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.seriesSettingItem, "center.1", "position2", "50%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.series." + this.index + ".center.1", false)
        this.seriesData.forEach((data, index) => {
          // 针对样式5 后面有那个半圆环的情况
          if (data.type === "gauge") {
            this.$changeOptionsEV(newVal + "%", "chartOption.series." + index + ".center.1", false)
          }
        })
      }
    },
    // 显示标签文字
    showLabel: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "label.show", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.show", false)
      }
    },
    labelFormatter: {
      get() {
        let formatterTypeNumber = 1
        if(this.seriesSettingItem.label.hasOwnProperty("formatterTypeNumber")){
          formatterTypeNumber = this.seriesSettingItem.label.formatterTypeNumber
        }else{
          let formatter = this.seriesSettingItem.label.formatter
          formatterTypeNumber = this.setFormatterTypeNumber(formatter)
        }
        return formatterTypeNumber
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.formatterTypeNumber", false)
        this.setFormatteTypeValue(newVal)
      }
    },
    labelFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "label.fontFamily", "labelFontFamily", 'sans-serif')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontFamily", false)
      }
    },
    labelFontColor: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.color", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontWeight", false)
      }
    },
    labelFontSize: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontSize", false)
      }
    },
    showLabelLine: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "labelLine.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".labelLine.show", false)
      }
    },
    labelSelectData: {
      get() {
        let pluginName = this.getOptions.chartOption.hasOwnProperty("pluginName")
          ? this.getOptions.chartOption.pluginName
          : []
        return pluginName.indexOf("labelFormaterStringToFuncPlugin") > -1 ? 2 : 1
      },
      set(val) {
        let pluginName = this.getOptions.chartOption.hasOwnProperty("pluginName")
          ? this.getOptions.chartOption.pluginName
          : []
        if (val === 1) {
          //样式1不要插件
          let index = pluginName.indexOf("labelFormaterStringToFuncPlugin")
          pluginName.splice(index, 1)
          this.getOptions.chartOption.series.forEach((item, index) => {
            this.$changeOptionsEV(null, "chartOption.series." + index + ".labelLayout", false)
          })
        } else if (val === 2) {
          //样式2带插件
          pluginName.push("labelFormaterStringToFuncPlugin")
        }
        this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
      }
    },
    labelColorType: {
      get() {
        return this.labelLineColor ? "custom" : "default"
      },
      set(val) {
        if (val === "default") {
          this.labelLineColor = null
        } else if (val === "custom") {
          this.labelLineColor = "#fff"
        }
      }
    },
    labelLineColor: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "labelLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".labelLine.lineStyle.color", false)
      }
    },
    labelLineWidth: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "labelLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".labelLine.lineStyle.width", false)
      }
    },
    labelLineType: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "labelLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".labelLine.lineStyle.type", false)
      }
    },
    labelType: {
      get() {
        // console.log();
        // return this.hasProperty(this.seriesSettingItem, "type")
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "roseType", "radius")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".roseType", false)
      }
    }
  },
  methods: {
    init() {
      this.initPieColorList()
    },
    // 初始化pieColorType
    initPieColorList() {
      let result = []
      this.seriesSettingItem.data.forEach(item => {
        // 纯色
        let obj = {}
        if (typeof item.itemStyle.color === "string") {
          obj = {
            type: "纯色",
            color: item.itemStyle.color
          }
        } else if (item.itemStyle.color.type === "linear") {
          // 线性渐变色
          obj = {
            type: "线性渐变",
            startColor: item.itemStyle.color.colorStops[0].color,
            endColor: item.itemStyle.color.colorStops[1].color
          }
        } else {
          // undefined，默认值为外层this.seriesSettingItem.itemStyle.color
          // console.log("this.seriesSettingItem.itemStyle.color", this.seriesSettingItem.itemStyle.color)
          const colorTemp = this.seriesSettingItem.itemStyle.color
          if (typeof colorTemp === "string") {
            obj = {
              type: "纯色",
              color: colorTemp
            }
          } else {
            obj = {
              type: "线性渐变",
              startColor: colorTemp.colorStops[0].color,
              endColor: colorTemp.colorStops[1].color
            }
          }
        }
        result.push(obj)
      })
      this.pieColorList = result
    },
    // 切换单色多色,每次切换的时候都要去修改chartOption，多色设置会覆盖掉单色设置
    changePieColorQuantity(index, colorItemType) {
      if (colorItemType === "纯色") {
        this.$set(this.pieColorList[index], "color", this.pieColorList[index].startColor)
      } else {
        this.$set(this.pieColorList[index], "startColor", this.pieColorList[index].color)
        this.$set(this.pieColorList[index], "endColor", this.pieColorList[index].color)
      }
    },
    checkFormatterValue() {
      if (!this.seriesSettingItem.label.formatter) {
        this.$changeOptionsEV("{c}{valueUnit| }", "chartOption.series." + this.index + ".label.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.series." + this.index + ".label.rich",
          false
        )
      }
    },
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    setFormatterTypeNumber(formatter){
      let formatterType = 1
      let typeArr = ["{b}", "{d}%", "{b}:{d}%", "{c}:{d}%", "{b}:{c}"]
      formatterType = typeArr.indexOf(formatter) + 1
      if(!formatterType){
        formatterType = 1
      }
      this.$changeOptionsEV(formatterType, "chartOption.series." + this.index + ".label.formatterTypeNumber", false)
      return formatterType
    },
    setFormatteTypeValue(newVal){
      let typeArr = ["{b}", "{d}%", "{b}:{d}%", "{c}:{d}%", "{b}:{c}"]
      let newVal1 = typeArr[newVal - 1]
      this.$changeOptionsEV(newVal1, "chartOption.series." + this.index + ".label.formatter", false)

    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.custom-color {
  display: inline-block;
  width: calc(100% - 72px);
  vertical-align: middle;
}
.pie-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.percent65_ {
  width: calc(100% - 65px);
}
  .data-source-type ::v-deep .el-radio__label{
    margin-left: -2px;
  }
</style>
